var exports = {
  "D": "xdbfd91f1--25c031--title",
};

module.exports = exports;
